import { Component, OnInit, Input } from '@angular/core';
import { GenericService } from 'app/services/generic/generic.service';

@Component({
  selector: 'app-carousel-generic',
  templateUrl: './carousel-generic.component.html',
  styleUrls: ['./carousel-generic.component.css']
})
export class CarouselGenericComponent implements OnInit {
  public responsiveOptions;
  public items = [];
  public carousel_circular;

  @Input() structure: any;
  @Input() index: number;

  // Carousel Values
  public minElement = 0;
  public maxElement = -1;
  public loaded = false;
  public breakpoints = [1024, 768, 560];
  public page = 0;
  public heightIMG = 1;

  constructor(private genericService: GenericService) {  
    this.setResponsiveOptions(3, 3, 2, 2, 1, 1);
  }

  ngOnInit(): void {
    console.log(this.structure[this.index]['items'], "iteeeems");
    this.setResponsiveOptions(this.structure[this.index]['carousel_num_visible'], this.structure[this.index]['carousel_num_scroll'], this.structure[this.index]['carousel_num_visible_s'], this.structure[this.index]['carousel_num_scroll_s'], this.structure[this.index]['carousel_num_visible_xs'], this.structure[this.index]['carousel_num_scroll_xs']);
    this.setPage(this.page, this.structure[this.index]['carousel_num_scroll'], this.structure[this.index]['carousel_num_visible'],
      this.structure[this.index]['carousel_num_scroll_s'], this.structure[this.index]['carousel_num_visible_s'], 
      this.structure[this.index]['carousel_num_scroll_xs'], this.structure[this.index]['carousel_num_visible_xs']);
  }

  public setPage(page, numScroll, numVisible, numScroll_s, numVisible_s, numScroll_xs, numVisible_xs) {
    setTimeout(() => {
      if(page.page !== undefined) this.page = page.page;
      console.log("page page:", page, numScroll, numVisible, numScroll_s, numVisible_s, numScroll_xs, numVisible_xs, this.page);
      let windowActual = window.innerWidth;
      if(windowActual > this.breakpoints[0]) {
        this.minElement = this.page * numScroll - 1;
        this.maxElement = this.minElement + numVisible + 1;
        this.heightIMG = numVisible;
      } else if(windowActual > 1250) {
        this.minElement = this.page * numScroll_s - 1;
        this.maxElement = this.minElement + numVisible_s + 1;
        this.heightIMG = numVisible_s;
      } else {
        this.minElement = this.page * numScroll_xs - 1;
        this.maxElement = this.minElement + numVisible_xs + 1;
        this.heightIMG = numVisible_xs;
      }
      if(!this.loaded) this.loaded = true;
    });
  }
  public setResponsiveOptions(numVisible, numScroll, numVisible_s, numScroll_s, numVisible_xs, numScroll_xs) {
    this.responsiveOptions = [
      {
        breakpoint: this.breakpoints[0] + "px",
        numVisible: numVisible,
        numScroll: numScroll
      },
      {
        breakpoint: this.breakpoints[1] + "px",
        numVisible: numVisible_s,
        numScroll: numScroll_s
      },
      {
        breakpoint: this.breakpoints[2] + "px",
        numVisible: numVisible_xs,
        numScroll: numScroll_xs
      }
    ];
  }
}
